<template>
  <div
    class="InputCheckbox flex align-center"
    :class="{ disabled: disabled }"
  >
    <input
      :id="id"
      :checked="checked"
      :disabled="disabled"
      type="checkbox"
      :value="value"
      @change="$emit('change', $event)"
    />
    <label
      :for="id"
      class="ml-sm"
    >
      {{ label }}
    </label>
  </div>
</template>

<script setup lang="ts">
  defineProps<{
    id: string
    checked: boolean
    disabled?: boolean
    value?: string
    label: string
  }>()

  defineEmits<{
    (e: 'change', event: Event): void
  }>()
</script>

<style scoped lang="scss">
  .InputCheckbox {
    &.disabled {
      opacity: 0.5;
      pointer-events: none;
    }

    input[type='checkbox'] {
      position: relative;
      width: 32px;
      height: 32px;
      border: 2px solid $black;
      border-radius: var(--border-radius-md);
      appearance: none;
      -webkit-appearance: none;
      -moz-appearance: none;
      cursor: pointer;

      &:hover {
        background-color: rgba(black, 0.8);
      }

      &:checked {
        background-color: black;

        &::before {
          content: '\e909';
          font-family: $font-icon;
          display: block;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          font-size: 24px;
          color: white;
          line-height: 1;
          text-align: center;
        }
      }
    }

    label {
      cursor: pointer;
      user-select: none;
    }
  }
</style>
